import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-video.svg";
import * as styles from "./Icon.module.scss";

type VideoProps = React.SVGProps<SVGSVGElement>;

export const Video = ({ className, ...props }: VideoProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
